var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "bg-brand-secondary font-archivo-narrow" },
    [
      _c("div", { staticClass: "py-3 mx-auto px-_5 md_py-5 container" }, [
        _c(
          "div",
          {
            staticClass:
              "w-full md_w-8-12 lg_w-6-12 flex flex-wrap justify-around lg_justify-between mx-auto"
          },
          _vm._l(_vm.columns, function(links, title) {
            return _c("footer-column", {
              key: title,
              attrs: {
                title: title,
                links: links,
                "open-default": title === "Company",
                height: _vm.heights[title]
              }
            })
          }),
          1
        ),
        _vm.domainConfig.display_powered_by_vs == 1
          ? _c(
              "div",
              { staticClass: "flex w-full mt-2 justify-around flex-wrap" },
              [
                _c("img", {
                  staticClass: "opacity-100 h-4 bg-white rounded-lg",
                  attrs: { src: _vm.poweredBanner }
                })
              ]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }